import { Call } from './../../../models/call.model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-call-item-responsive',
  templateUrl: './list-call-item-responsive.component.html',
  styleUrls: ['./list-call-item-responsive.component.scss']
})
export class ListCallItemResponsiveComponent implements OnInit {

  @Input() calls: any;

  public statusColors: any = [
    {
      color: 'bg-waiting',
      status: 'ABERTO'
    },
    {
      color: 'bg-attending',
      status: 'ATENDENDO'
    },
    {
      color: 'bg-solved',
      status: 'RESOLVIDO'
    },
    {
      color: 'bg-closed',
      status: 'FECHADO'
    },
    {
      color: 'bg-canceled',
      status: 'CANCELADO'
    },
    {
      color: 'bg-pending',
      status: 'PENDENTE'
    }
  ]
  constructor() { }

  ngOnInit(): void {
  }

  public classesByState(call: Call): string {
    switch (call.status) {
      case 'T': return 'bg-attending';
      case 'P': return 'bg-pending';
      case 'R': return 'bg-solved';
      case 'F': return 'bg-closed';
      case 'C': return 'bg-canceled';
      default: return 'bg-waiting';
    }
  }

  public borderColorByState(call: Call) {
    switch (call.status) {
      case 'T': return '#08a65c';
      case 'P': return '#d84747';
      case 'R': return '#0d448c';
      case 'F': return '#a8a8a8';
      case 'C': return '#3d3f47';
      default: return '#f07e21';
    }
  }

  public goToCall(call_id) {
    window.open(`/operador/chamados/${ call_id }`);
  }
}
